import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { checkTypeIsAiPPT, checkTypeIsPPT } from '@meitu/saas-editor-ui/es/utils/stage';
import { useRecordModel } from '@/store/models/record-model';
import { useSdkModel } from '@/store/models/sdk-model';
import { useTemplateModel } from '@/store/models/template-model';
import { IEditorType } from '@/types';
import { checkImageEditor } from '@/utils/common';
import { getMenus } from './config';

export const useMenu = () => {
    // --- store states ---
    const canvasType = useTemplateModel((state) => state.canvasType);
    const posterType = useRecordModel((state) => state.posterType);
    const customParams = useSdkModel((state) => state.customParams);
    const canShowReplaceAiPPTCollapse = useTemplateModel((state) => state.canShowReplaceAiPPTCollapse);

    // --- computed ---
    const editorType = checkImageEditor() ? IEditorType.imageEditor : IEditorType.posterEditor;

    const isNormalPPT = checkTypeIsPPT(canvasType);
    const isAIPPT = checkTypeIsAiPPT(posterType);
    const isPPTMode = isNormalPPT || isAIPPT;

    const hiddenMenus: Array<CollapseType> = (() => {
        const ret = [] as Array<CollapseType>;

        if (customParams && customParams.hideMenus && customParams.hideMenus.length > 0) {
            ret.push(...(customParams.hideMenus as Array<CollapseType>));
        }

        if (isAIPPT && !canShowReplaceAiPPTCollapse) {
            ret.push(CollapseType.TEMPLATE_MENU);
        }

        return ret;
    })();

    const menus = getMenus(editorType, isPPTMode, hiddenMenus);

    return { menus };
};
